(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mh-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mh-story')) {
    class MhStory extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.isInit || !this.isConnected) return;
        this.steps = Array.from(this.querySelectorAll('.mh-story__step'));
        this.markers = Array.from(this.querySelectorAll('.mh-story__marker'));
        if (this.steps.length < 2 || !('IntersectionObserver' in window)) return;
        this.isInit = true;
        this.cur = this.querySelector('.mh-story__progress-cur');
        this.fill = this.querySelector('.mh-story__rail-fill');
        this.active = 0;
        this.classList.add('is-js');

        this.mq = window.matchMedia('(min-width: 990px)');
        this.onChange = () => this.setup();
        this.mq.addEventListener('change', this.onChange);

        this.onBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const step = event.target.closest('.mh-story__step');
          if (step) this.setActive(Number(step.dataset.index));
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.setup();
      }

      setup() {
        if (this.observer) this.observer.disconnect();
        if (!this.mq.matches) {
          this.steps.forEach((el) => el.classList.remove('is-active'));
          return;
        }
        this.setActive(this.active);
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index));
            });
          },
          { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
        );
        this.markers.forEach((el) => this.observer.observe(el));
      }

      setActive(index) {
        if (index < 0 || index >= this.steps.length) return;
        this.active = index;
        this.steps.forEach((el, i) => el.classList.toggle('is-active', i === index));
        if (this.cur) {
          const num = this.steps[index].querySelector('.mh-story__num');
          this.cur.textContent = num ? num.textContent.trim() : String(index + 1).padStart(2, '0');
        }
        if (this.fill) {
          this.fill.style.setProperty('--mh-p', ((index + 1) / this.steps.length) * 100 + '%');
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mq) this.mq.removeEventListener('change', this.onChange);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.isInit = false;
      }
    }
    customElements.define('mh-story', MhStory);
  }

  } catch(e) { console.error(e); }
})();
})();
